import React from "react";
import moment from "moment";
import { Hammenu } from "./";
import { useSelector } from "react-redux";

const MeetingsList = ({
  spotlightMeeting,
  meetingData,
  setSpotlight,
  setAction,
  listType,
}) => {
  const [hoverId, setHoverId] = React.useState(null);
  const current_day = moment().format("MMM DD");
  const current_time = moment().format("yyyy-MM-DDTHH:mm:ss");

  const state = useSelector((state) => state.UserReducer);

  const getMeetingStatus = (item) => {
    if (
      moment(item.from_time).format("yyyy-MM-DDTHH:mm:ss") <= current_time &&
      moment(item.till_time).format("yyyy-MM-DDTHH:mm:ss") >= current_time
    )
      return (
        <span className='bg-yellow-100 text-yellow-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded '>
          Now
        </span>
      );
    else if (
      item.recurring === false &&
      current_time > moment(item.till_time).format("yyyy-MM-DDTHH:mm:ss")
    ) {
      if (item.validflag === 3)
        return (
          <span className='bg-green-100 text-green-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded '>
            Completed
          </span>
        );
      else if (item.validflag === 1)
        return (
          <span className='bg-red-100 text-red-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded '>
            Pending MOM
          </span>
        );
    }
    return (
      <span className='bg-gray-100 text-gray-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded '>
        Not Started
      </span>
    );
  };

  const attendeeBadge = (item) => {
    // console.log(item.organizedBy + " - " + state.user._id);
    let isAttendee = false;
    item.attendeesRequired.map((item) => {
      if (item.user === state.user._id) isAttendee = true;
    });
    if (item.organizedBy === state.user._id)
      return (
        <span className='bg-blue-100 text-blue-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded'>
          Organizer
        </span>
      );
    else if (isAttendee)
      return (
        <span className='bg-gray-100 text-gray-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded'>
          Attendee
        </span>
      );
    else if (item.notesTaker === state.user._id)
      return (
        <span className='bg-indigo-100 text-indigo-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded '>
          Notes Taker
        </span>
      );
  };

  const timeKeeperBadge = (item) => {
    if (item.timeKeeper === state.user._id)
      return (
        <span className='bg-purple-100 text-purple-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded '>
          Time Keeper
        </span>
      );
  };

  return (
    <div className='w-full overflow-y-auto p-2 flex flex-col space-y-3'>
      {meetingData.length > 0 ? (
        meetingData.map((item) => (
          <div
            key={item._id}
            className={`${
              item.recurring === false && current_time > item.till_time
                ? "opacity-100"
                : "opacity-100"
            } px-1.5 pl-3 py-1.5 rounded-sm flex flex-col space-y-0.5 duration-200 cursor-default border-r-4  ${
              item?._id === spotlightMeeting
                ? "bg-yellow-100"
                : item?._id === hoverId
                ? "bg-yellow-50"
                : "bg-gray-300"
            } ${
              item?._id === spotlightMeeting
                ? "border-yellow-dark"
                : "border-gray-200"
            }`}
            onClick={(event) => {
              event.preventDefault();
              setSpotlight(item._id);
            }}
            onMouseOut={(event) => {
              setHoverId(null);
            }}
            onMouseOver={(event) => {
              setHoverId(item._id);
            }}>
            <div className='flex justify-between'>
              <span className='font-medium text-sm text-yellow-dark overflow-hidden'>
                {item.topic.length > 28
                  ? item.topic.slice(0, 25).trim() + "..."
                  : item.topic}
              </span>
              {item.organizedBy === state.user._id && (
                <div className='opacity-100 z-40'>
                  <Hammenu
                    hoverId={hoverId}
                    item={item}
                    setAction={setAction}
                    listType={listType}
                  />
                </div>
              )}
            </div>
            <div className='flex justify-between'>
              <span className='font-medium text-xs text-gray-dark'>
                {(item.recurring
                  ? "Recurring, "
                  : moment(item.from_time).format("MMM DD") === current_day
                  ? "Today, "
                  : moment(item.from_time).format("MMM DD, ")) +
                  moment(item.from_time).format("hh:mmA")}
                {" - "}
                {moment(item.from_time).format("MMM DD") ===
                moment(item.till_time).format("MMM DD")
                  ? moment(item.till_time).format("hh:mmA")
                  : moment(item.till_time).format("MMM DD, hh:mmA")}
              </span>
            </div>
            <div className='flex justify-between'>
              <div className=''>{getMeetingStatus(item)}</div>
              <div className=''>
                <>
                  {attendeeBadge(item)}{" "}
                  {item.organizedBy !== state.user._id && timeKeeperBadge(item)}
                </>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className='flex justify-center py-6'>
          <span className='font-normal text-lg'>None scheduled</span>
        </div>
      )}
    </div>
  );
};

export default MeetingsList;
